import * as React from 'react';
import { cn } from '@/lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, ...props }, ref) => (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'w-full rounded-sm border bg-raised px-2 py-1.5 text-sm text-ink placeholder:text-ink-3',
        'border-rule-strong transition-colors focus:border-live focus:outline-none focus:ring-1 focus:ring-live',
        'disabled:cursor-not-allowed disabled:bg-sunken disabled:text-ink-3',
        invalid && 'border-danger focus:border-danger focus:ring-danger',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
